"use client";
import React from "react";
/**
 * The context's default value is used when there is no provider, or in gatsby during SSR.
 * We default to
 */
const defaultContextForSSR = {
    getItem: () => null,
    setItem: () => null,
    removeItem: () => null,
};
export const makeGenericStorageContext = (displayName) => {
    const CTX = React.createContext(defaultContextForSSR);
    CTX.displayName = displayName;
    return CTX;
};
export const useStorageContext = (context) => {
    const ctx = React.useContext(context);
    if (!ctx) {
        throw new Error(`Context ${context.displayName} must be used within a provider, perhaps you forgot to enable this store in the plugin configuration?`);
    }
    return ctx;
};
//# sourceMappingURL=context.js.map